import type { TerritorialWidget } from '@/features/dashboard/types'

export interface TopTerritory {
  label: string
  count: number
}

/**
 * Deriva el territorio con mayor actividad documental a partir de datos
 * reales (TerritorialWidget) — usado tanto por el hero del Centro de
 * Inteligencia (`DashboardHero`) como por el Topbar (`useActiveTerritory`),
 * para que ambos usen exactamente el mismo cálculo, sin una segunda lógica
 * territorial paralela. Nunca fija un municipio hardcodeado: si no hay
 * datos, devuelve `null`.
 */
export function deriveTopTerritory(data: TerritorialWidget | undefined): TopTerritory | null {
  const topMunicipality = [...(data?.municipalities ?? [])].sort((a, b) => b.document_count - a.document_count)[0]
  const topState = [...(data?.states ?? [])].sort((a, b) => b.document_count - a.document_count)[0]

  if (!topMunicipality && !topState) return null

  const label = topMunicipality
    ? `${topMunicipality.municipality}, ${topMunicipality.state}`
    : (topState?.state ?? '')
  const count = topMunicipality?.document_count ?? topState?.document_count ?? 0
  return { label, count }
}
